import React from 'react';

export const TeamIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.08333 8.33348C8.69417 8.33348 10 7.02765 10 5.41681C10 3.80598 8.69417 2.50015 7.08333 2.50015C5.4725 2.50015 4.16667 3.80598 4.16667 5.41681C4.16667 7.02765 5.4725 8.33348 7.08333 8.33348ZM12.9167 8.33348C14.3475 8.33348 15.5 7.18098 15.5 5.75015C15.5 4.31932 14.3475 3.16681 12.9167 3.16681C11.4858 3.16681 10.3333 4.31932 10.3333 5.75015C10.3333 7.18098 11.4858 8.33348 12.9167 8.33348ZM7.08333 10.0001C4.72333 10.0001 0 11.1826 0 13.5418V15.8335H14.1667V13.5418C14.1667 11.1826 9.44333 10.0001 7.08333 10.0001ZM12.9167 10.0001C12.6417 10.0001 12.3267 10.0168 12 10.0418C13.2183 10.8701 14.1667 12.0335 14.1667 13.5418V15.8335H20V13.5418C20 11.1826 15.2767 10.0001 12.9167 10.0001Z"
      fill="currentColor"
    />
  </svg>
);
